import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { debounceTime, distinctUntilChanged, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductosService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/productos', httpClient, authService);
  }
  buscarProductos(termino: string): Observable<any[]> {
    return this.httpClient.post<any[]>(`${this.apiBaseUrl }v1/productos/buscar`, { termino }).pipe(
      debounceTime(300), // Evitar demasiadas solicitudes
      distinctUntilChanged() // No repetir si el término no cambió
    );
  }
}
